import ProductRecommendation from 'ai/components/SuperChat/ProductRecommendation/ProductRecommendation';
import { withProductRecommendationProps } from 'ai/viewModel/superChat/productRecommendation/withProductRecommendationProps';

export default withProductRecommendationProps(ProductRecommendation);
